// extracted by mini-css-extract-plugin
export default {"indexWrapper":"styles_indexWrapper__TBpcA","globeWrapper":"styles_globeWrapper__hGL6x","topWrapper":"styles_topWrapper__j2Nt5"};